import NutritionInformationService from 'src/modules/nutritionInformation/nutritionInformationService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { i18n } from 'src/i18n';
import { navigateTo } from 'src/view/shared/routes/helpers';

const prefix = 'NUTRITIONINFORMATION_FORM';

const nutritionInformationFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: nutritionInformationFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await NutritionInformationService.find(id);
      }

      dispatch({
        type: nutritionInformationFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: nutritionInformationFormActions.INIT_ERROR,
      });

      navigateTo('/library/nutrition-information');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: nutritionInformationFormActions.CREATE_STARTED,
      });

      await NutritionInformationService.create(values);

      dispatch({
        type: nutritionInformationFormActions.CREATE_SUCCESS,
      });

      Message.success(i18n('entities.nutritionInformation.create.success'));

      navigateTo('/library/nutrition-information');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: nutritionInformationFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: nutritionInformationFormActions.UPDATE_STARTED,
      });

      await NutritionInformationService.update(id, values);

      dispatch({
        type: nutritionInformationFormActions.UPDATE_SUCCESS,
      });

      Message.success(i18n('entities.nutritionInformation.update.success'));

      navigateTo('/library/nutrition-information');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: nutritionInformationFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default nutritionInformationFormActions;
